module.exports = __webpack_public_path__ + "static/img/ganPin-map.3286eef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ganPin-map.jpg
// module id = X4fC
// module chunks = 1